export default __webpack_public_path__ + "static/media/click2.6ac40617.wav";